<div class="ch-checkbox-group">
  <span class="ch-checkbox-item" *ngFor="let i of checkboxValues; let ix = index">
    <input (change)="checkboxChange(ix, $event.target)" [checked]="isChecked(i.value)" type="checkbox" class="form-check-input" />
    <span>{{ i.value }}</span>
  </span>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/checkbox-group/checkbox-group.component.html